import React from "react";
import GameMap from "./logic/GameMap";
import { mapConfigs } from "./MapConfig/mapConfigs";

export default function Route25() {
  return <GameMap config={mapConfigs.route25} />;
}